"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = Arrow;
var _react = _interopRequireDefault(require("react"));
function Arrow() {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "10",
    height: "16",
    viewBox: "0 0 10 16"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fill: "none",
    "fill-rule": "evenodd",
    stroke: "#2F2E2E",
    "stroke-width": "1.5",
    d: "M1.071 1l7.071 7.071-7.07 7.071"
  }));
}